import React from "react";
import style from "./style/Tab.module.scss";

export interface TabProps {
  /**
   * Label of the tab.
   */
  label: string;
  /**
   * The id of the tab.
   */
  id: string;
  /**
   * Determines if the tab is active.
   */
  isActive: boolean;
  /**
   * Optional custom class overrides.
   */
  classes: {
    tab?: string;
    tabActive?: string;
  };
  /**
   * Callback for tab click event.
   */
  onClick: () => void;
}

export const Tab = ({ label, isActive, classes = {}, onClick }: TabProps): JSX.Element => {
  return (
    <li
      className={[
        style.tab,
        classes?.tab || '',
        isActive ? classes?.tabActive || style.tabActive : '',
      ].join(' ')}
      onClick={onClick}
    >
      {label}
    </li>
  );
};

